import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const NoMediaIcon = (props: IconProps) => (
  <IconBase viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 0a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V2a2 2 0 00-2-2H2zm0 12h4v4H2v-4zm-2 0a2 2 0 012-2h4a2 2 0 012 2v4a2 2 0 01-2 2H2a2 2 0 01-2-2v-4zM16 2h-4v4h4V2zm-4-2a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V2a2 2 0 00-2-2h-4zm0 12h4v4h-4v-4zm-2 0a2 2 0 012-2h4a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2v-4z"
      fill="currentColor"
    />
  </IconBase>
);

export default NoMediaIcon;
